<template>
  <div class="dashboard-wrapper">
    <header class="dashboard-header">
      <h1>Verificador de Zelle</h1>
      <button @click="logout" class="logout-button">Cerrar Sesión</button>
    </header>
    <main class="dashboard-content">
      <h2>¡Bienvenido, {{ userName }}!</h2>
      <div class="stats-container">
        <div class="stat-card">
          <h3>Zelles Asignados</h3>
          <p class="stat-value">{{ assignedZelles }}</p>
        </div>
        <div class="stat-card">
          <h3>Saldo Zelles Asignados</h3>
          <p class="stat-value">${{ formattedAssignedBalance }}</p>
        </div>
        <router-link to="/verify" class="stat-card action-card">
          <h3>Verificar Pago</h3>
          <p class="action-text">Haz clic aquí para verificar un nuevo pago</p>
        </router-link>
        <router-link to="/history" class="stat-card action-card">
          <h3>Historial de Pagos</h3>
          <p class="action-text">Consulta tus pagos Zelle registrados</p>
        </router-link>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'WelcomeComponent',
  data() {
    return {
      userName: '',
      assignedZelles: 0,
      assignedBalance: 0
    };
  },
  created() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.nombre) {
      this.userName = user.nombre;
      this.fetchAssignedCount(user.co_cli);
      this.fetchAssignedBalance(user.co_cli);
    } else {
      this.$router.push('/');
    }
  },
  computed: {
    formattedAssignedBalance() {
      return this.assignedBalance.toFixed(2);
    }
  },
  methods: {
    async fetchAssignedBalance(clientId) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/zelle/cliente/${clientId}/asignados/saldo`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.assignedBalance = response.data.total;
      } catch (error) {
        console.error('Error fetching assigned Zelle balance:', error);
        this.assignedBalance = 0;
      }
    },
    async fetchAssignedCount(clientId) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/zelle/cliente/${clientId}/asignados/count`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        this.assignedZelles = response.data.count;
      } catch (error) {
        console.error('Error fetching assigned Zelle count:', error);
        this.assignedZelles = 0; // Reset on error
      }
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.dashboard-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f0f2f5;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.dashboard-header h1 {
  font-size: 24px;
  color: #333;
  margin: 0;
}

.logout-button {
  padding: 8px 16px;
  font-size: 14px;
  color: #fff;
  background-color: #e74c3c;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.logout-button:hover {
  background-color: #c0392b;
}

.dashboard-content {
  padding: 40px 30px;
}

.dashboard-content h2 {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 30px;
}

.stats-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.stat-card {
  background-color: #fff;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.stat-card h3 {
  font-size: 18px;
  color: #666;
  margin-bottom: 15px;
}

.stat-value {
  font-size: 36px;
  font-weight: 700;
  color: #42b983;
}

.action-card {
  background-color: #42b983;
  color: #fff;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.3s, box-shadow 0.3s;
}

.action-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.action-card h3 {
  color: #fff;
}

.action-text {
  font-size: 16px;
  margin-top: 10px;
}
</style>
